<template>
<!-- The component requires the selected filters in text-value arraypairs
		The Selected filters have to have the following names:
		mandators, salesChannels, serviceProviders, products,
		skuGroups, dateFrom, dateTill, grouping, booking, resellers, paymentMethods,
-->
	<v-flex xs12 sm10 offset-sm1 md10 offset-md1 lg10 offset-lg1>
		<div
			class="text-xs-center"
			style="height:45px; overflow: hidden; white-space: nowrap; overflow-x: scroll"
		>
			<v-chip color="rgba(10,10,10,0.9)" text-color="white"
				>{{ selectedFilters.dateFrom }} ---
				{{ selectedFilters.dateTill }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				>{{ selectedFilters.grouping }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="mandator in selectedFilters.mandators"
				v-bind:data="mandator.text"
				v-bind:key="mandator.value"
				>{{ mandator.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="region in selectedFilters.allowedRegions"
				v-bind:data="region.region_name"
				v-bind:key="region.region_id"
				>{{ region.region_name }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="salesChannels in selectedFilters.salesChannels"
				v-bind:data="salesChannels.text"
				v-bind:key="salesChannels.value"
				>{{ salesChannels.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="serviceProviders in selectedFilters.serviceProviders"
				v-bind:data="serviceProviders.text"
				v-bind:key="serviceProviders.value"
				>{{ serviceProviders.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="serviceprovider in selectedFilters.products"
				v-bind:data="serviceprovider.text"
				v-bind:key="serviceprovider.text"
				>{{ serviceprovider.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="skuGroups in selectedFilters.skuGroups"
				v-bind:data="skuGroups.text"
				v-bind:key="skuGroups.text"
				>{{ skuGroups.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="booking in selectedFilters.booking"
				v-bind:data="booking.text"
				v-bind:key="booking.text"
				>{{ booking.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="resellers in selectedFilters.resellers"
				v-bind:data="resellers.text"
				v-bind:key="resellers.text"
				>{{ resellers.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="paymentMethods in selectedFilters.paymentMethods"
				v-bind:data="paymentMethods.text"
				v-bind:key="paymentMethods.text"
				>{{ paymentMethods.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.5)"
				text-color="black"
				v-for="shoppingCartRules in selectedFilters.shoppingCartRules"
				v-bind:data="shoppingCartRules.text"
				v-bind:key="shoppingCartRules.text"
				>{{ shoppingCartRules.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="cashdesk in selectedFilters.cashdesk"
				v-bind:data="cashdesk.text"
				v-bind:key="cashdesk.text"
				>{{ cashdesk.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="status in selectedFilters.itemStatus"
				v-bind:data="status.text"
				v-bind:key="status.value"
				>{{ status.text }}
			</v-chip>
		</div>
	</v-flex>
</template>

<script>
export default {
	name: 'ReportingSystemSelectedFilter',
	props: ['selectedFilters'],
	data() {
		return {
			selectedRegstatus: '',
		}
	},
}
</script>

<style scoped>
.text-xs-center {
	height: 45px;
	overflow: hidden;
	white-space: nowrap;
	overflow-x: scroll;
}

.v-chip {
	margin-left: 5px;
}

</style>
